export default __webpack_public_path__ + "static/media/yellow_two.8577a172.jpg";